import { Card } from '@/components/Card'
import styles from './JobWidgetView.module.css'
import type { ReactNode } from 'react'

export interface JobWidgetViewProps {
  header: ReactNode
  step?: ReactNode
  bookedTime?: ReactNode
  button: ReactNode
  children: ReactNode
}

export function JobWidgetView({
  header,
  children,
  bookedTime,
  button,
}: JobWidgetViewProps) {
  return (
    <div className={styles.root}>
      {header}

      <Card>
        {bookedTime && (
          <div className={styles.consultationBookedTime}>{bookedTime}</div>
        )}

        <div className={styles.content}>{children}</div>
      </Card>

      {button}
    </div>
  )
}
